import { ChevronDown, ChevronRight, Trash2 } from "lucide-react";
import { money } from "@/lib/format";
import { Calc, GmCalc } from "./GridCell";

const td = "h-10 border-b border-slate-200 px-1 bg-slate-50";

// Collapsible section row: code · NAME · summary, with the scope's roll-up in the number columns.
export function GridScopeRow({ scope, scopeIdx, expanded, onToggle, onRename, onRemove, canRemove, roll, reviewCount, cols }) {
  return (
    <tr className="cursor-pointer" onClick={onToggle} data-testid={`scope-${scopeIdx}`}>
      <td className={`${td} w-6 text-center`}>
        {expanded ? <ChevronDown className="mx-auto h-3.5 w-3.5 text-slate-400" /> : <ChevronRight className="mx-auto h-3.5 w-3.5 text-slate-400" />}
      </td>
      <td className={`${td} px-2`} colSpan={2}>
        <div className="flex min-w-0 items-center gap-2">
          <span className="shrink-0 rounded bg-slate-200 px-1.5 py-px font-mono text-[10.5px] text-slate-600">{String(scopeIdx + 1).padStart(2, "0")}</span>
          <input value={scope.name} onChange={(e) => onRename(e.target.value)} onClick={(e) => e.stopPropagation()} placeholder="Scope name"
            className="h-7 min-w-[120px] max-w-[260px] flex-1 border-b border-transparent bg-transparent text-[12.5px] font-bold uppercase tracking-wide text-slate-800 outline-none placeholder:normal-case placeholder:font-normal placeholder:text-slate-400 focus:border-brand"
            style={{ fontFamily: "var(--font-heading)" }}
            data-testid={`input-scope-name-${scopeIdx}`} />
          {reviewCount > 0 && (
            <span className="shrink-0 whitespace-nowrap text-[11px] font-semibold text-amber-600" data-testid={`scope-review-count-${scopeIdx}`}>{reviewCount} to review</span>
          )}
          {roll.subcontract > 0 && <span className="sr-only" data-testid={`scope-sub-total-${scopeIdx}`}>{money(roll.subcontract)}</span>}
          {canRemove && (
            <button type="button" aria-label="Remove Scope" className="ml-1 shrink-0 rounded p-1 text-slate-400 hover:bg-slate-200 hover:text-slate-700" onClick={(e) => { e.stopPropagation(); onRemove(); }} data-testid={`btn-remove-scope-${scopeIdx}`}>
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </td>
      <td className={`${td} border-l`}></td>
      <td className={td}></td>
      <td className={td}><Calc value={roll.material} testId={`scope-material-${scopeIdx}`} /></td>
      <td className={`${td} border-l`}><Calc kind="hours" value={roll.hours} testId={`scope-hours-${scopeIdx}`} /></td>
      {cols.hrsTotal && <td className={td}></td>}
      <td className={td}></td>
      {cols.rate && <td className={td}></td>}
      <td className={td}><Calc value={roll.labor} testId={`scope-labor-${scopeIdx}`} /></td>
      {cols.freight && <td className={`${td} border-l`}><Calc value={roll.freight} /></td>}
      <td className={`${td} ${cols.freight ? "" : "border-l"}`}></td>
      <td className={td}><Calc strong value={roll.total} testId={`scope-total-${scopeIdx}`} /></td>
      <td className={td}><GmCalc value={roll.gm} testId={`scope-gm-${scopeIdx}`} /></td>
      {cols.stock && <td className={`${td} border-l`}></td>}
    </tr>
  );
}
